import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionSignupComponent } from './subscription-signup/subscription-signup.component';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { GraphService } from '../services/graph.service';
import { AuthService } from '../services/auth.service';
import { MsalModule } from '@azure/msal-angular';
import { OAuthSettings } from '../Ms Grapgh API files/oauth';
import { PopUpModalComponent } from './pop-up-modal/pop-up-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SlickCarouselModule } from 'ngx-slick-carousel';

const routes: Routes = [
  { path: '',component: SubscriptionSignupComponent},
]

@NgModule({
  declarations: [
    SubscriptionSignupComponent,
    PopUpModalComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgbModule,
    RouterModule.forChild(routes),
    SlickCarouselModule,
    MsalModule.forRoot({
      auth: {
        clientId: OAuthSettings.appId
      }
    })
  ],
  exports: [
    RouterModule,
    SharedModule
  ],
  providers: [
    GraphService,
    AuthService,
  ]
})
export class SignupmoduleModule { }
